import { c as _c } from "react/compiler-runtime";
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { twMerge } from 'tailwind-merge';
import BlockIcon from '~/components/blocks/BlockIcon';
import CompletionTag from '~/components/blocks/CompletionTag';
import { CourseUnit } from '~/payload-types';
import { SupportedLocales } from '~/types';
import BookmarkRemovalButton from './BookmarkRemovalButton';
interface BookmarkEntryProps {
  block: CourseUnit['components'][0];
  summary?: string | null;
  moduleTitle: string;
  unitTitle: string;
  blockIdentifier: string;
  courseId: number;
  moduleId: number;
  unitId: number;
}
function BookmarkEntry(t0) {
  const $ = _c(49);
  const {
    block,
    summary,
    moduleTitle,
    unitTitle,
    blockIdentifier,
    courseId,
    moduleId,
    unitId
  } = t0;
  const t = useTranslations();
  const params = useParams();
  const blockUrl = `/${params.locale}/course/${courseId}/module/${moduleId}/unit/${unitId}/block/${blockIdentifier}`;
  let t1;
  if ($[0] !== block.blockType) {
    t1 = <BlockIcon blockType={block.blockType} />;
    $[0] = block.blockType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== block.title) {
    t2 = <div className="text-primary hover:underline font-medium">{block.title}</div>;
    $[2] = block.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== summary) {
    t3 = summary && <div className="mr-8 text-sm text-gray-600">{summary}</div>;
    $[4] = summary;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!summary && "mt-1.5";
  let t5;
  if ($[6] !== t4) {
    t5 = twMerge("flex flex-row items-center gap-3 text-sm italic text-gray-500", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faArrowRight} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== moduleTitle || $[10] !== t) {
    t7 = t("bookmarks.moduleTitle", {
      title: moduleTitle
    });
    $[9] = moduleTitle;
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div>{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FontAwesomeIcon icon={faArrowRight} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t || $[16] !== unitTitle) {
    t10 = t("bookmarks.unitTitle", {
      title: unitTitle
    });
    $[15] = t;
    $[16] = unitTitle;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <div>{t10}</div>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t5 || $[22] !== t8) {
    t12 = <div className={t5}>{t6}{t8}{t9}{t11}</div>;
    $[20] = t11;
    $[21] = t5;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t2 || $[26] !== t3) {
    t13 = <div className="flex flex-col">{t2}{t3}{t12}</div>;
    $[24] = t12;
    $[25] = t2;
    $[26] = t3;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== blockUrl || $[29] !== t1 || $[30] !== t13) {
    t14 = <Link href={blockUrl} className="flex flex-row items-center gap-2 flex-1 hover:bg-gray-50 transition-colors p-2 -m-2 rounded">{t1}{t13}</Link>;
    $[28] = blockUrl;
    $[29] = t1;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== block.time || $[33] !== blockIdentifier || $[34] !== courseId || $[35] !== moduleId || $[36] !== unitId) {
    t15 = <CompletionTag courseId={courseId} moduleId={moduleId} unitId={unitId} blockIdentifier={blockIdentifier} blockTime={block.time} />;
    $[32] = block.time;
    $[33] = blockIdentifier;
    $[34] = courseId;
    $[35] = moduleId;
    $[36] = unitId;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== blockIdentifier || $[39] !== courseId || $[40] !== moduleId || $[41] !== unitId) {
    t16 = <BookmarkRemovalButton courseId={courseId} moduleId={moduleId} unitId={unitId} blockIdentifier={blockIdentifier} />;
    $[38] = blockIdentifier;
    $[39] = courseId;
    $[40] = moduleId;
    $[41] = unitId;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t15 || $[44] !== t16) {
    t17 = <div className="my-auto flex flex-col gap-2 ml-2">{t15}{t16}</div>;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t14 || $[47] !== t17) {
    t18 = <div className="border-b"><div className="flex flex-row justify-between">{t14}{t17}</div></div>;
    $[46] = t14;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
}
export default BookmarkEntry;